import { cn } from "@/lib/utils";
import { dateLocale, type DateFormat, type TimeFormat, withClock } from "@/lib/dateTime";

const SAMPLE = new Date(2026, 0, 1, 14, 30);
const preview = (f: TimeFormat) => SAMPLE.toLocaleTimeString(dateLocale("dmy"), withClock({ hour: "2-digit", minute: "2-digit" }, f)).toUpperCase();
/** "21 Oct 2026 · 21/10/2026" in that order, for the date-style cards */
const DAY = new Date(2026, 9, 21);
export const datePreview = (f: DateFormat) => `${DAY.toLocaleDateString(dateLocale(f), { day: "numeric", month: "short", year: "numeric" })} · ${DAY.toLocaleDateString(dateLocale(f), { day: "2-digit", month: "2-digit", year: "numeric" })}`;

export type TimeChoice = { value: string; label: string; format: TimeFormat | null; note?: string; preview?: string };

/** Radio cards for the clock style, each with a live example, so nobody has to guess what "24-hour" looks like */
export function TimeFormatChoice({ value, onChange, options, name }: { value: string; onChange: (v: string) => void; options: TimeChoice[]; name: string }) {
  return (
    <div role="radiogroup" aria-label={name} className="grid gap-2 sm:grid-cols-3">
      {options.map((o) => {
        const on = o.value === value;
        return (
          <label key={o.value} className={cn("flex cursor-pointer flex-col gap-0.5 rounded-lg border px-3 py-2.5 transition-colors focus-within:ring-2 focus-within:ring-ring", on ? "border-primary bg-primary/5" : "border-border hover:bg-muted/50")}>
            <input type="radio" name={name} value={o.value} checked={on} onChange={() => onChange(o.value)} className="sr-only" />
            <span className="text-sm font-semibold text-foreground">{o.label}</span>
            <span className="font-mono text-xs text-muted-foreground">{o.preview ?? (o.format ? preview(o.format) : o.note)}</span>
          </label>
        );
      })}
    </div>
  );
}
